module.exports = __webpack_public_path__ + "static/img/shan-smile.acf8e9be.png";